<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Expired Devices" />
 
		<div class="container-fluid">

			<div class="card">
				<div class="card-body">
		
					<div class="col-md-12 project-list filter-sort">
						<div class="row">

							<div class="col-md-3">
                                       
                            </div>

							<div class="col-md-3"></div>
									
							<div class="col-md-3">
								<label class="control-label">Start Date:</label>
								<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchDeviceRenewal()">
							</div>
							<div class="col-md-3">
								<label class="control-label">End Date:</label>
								<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchDeviceRenewal()">
							</div>
									
						</div>
					</div>
				</div>
			</div>
			
			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-8 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchDeviceRenewal()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
								<span v-if="imei" class="ms-3 text-muted">
									Found {{ renewal_devices.length }} result{{ renewal_devices.length !== 1 ? 's' : '' }}
								</span>
							</div>
							<!-- <div class="col-md-2 mb-2">
								<div class="page-loader" v-if="Boolean(renewal_devices.length)">
									<button type="button" class="btn btn-info" v-if="!pdf.loading" @click="generatePDF()">Print</button>
									<img class="page-loader float-end" v-else src="@/assets/images/ajax-loader.gif"/>
								</div>
							</div> -->

                            <div class="col-md-2 mb-2">
								<div class="page-loader" v-if="Boolean(renewal_devices.length)">
									<button type="button" class="btn btn-info" v-if="!excel.loading" @click="generateExcel()">Excel</button>
									<img class="page-loader float-end" v-else src="@/assets/images/ajax-loader.gif"/>
								</div>
							</div>
							<div class="col-md-2">
								<div class="input-group">
									<input type="text" class="form-control" placeholder="IMEI" v-model="imei" @input="onImeiSearch" />
								</div>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI & ICCID</th>
									<th>Vehicle Number <br>
										Dealer
									</th>
									<th>Expired At</th>
									<th>Enquiry By</th>
									<th>Enquiry On</th>
                                    <th>Request By</th>
                                    <th>Recharged By</th>
									<th>Renewed By</th>
									<th>Payment By</th>
									<th>Payment Type</th>
									<th>Amount</th>
									<th>Payment Status</th>
                                    <th>Action</th>
								</tr>
							</thead>

							<tbody v-if="Boolean(renewal_devices.length)">
								<tr v-for="(device) in renewal_devices" :key="device.device_id" align="center">
                                    <td>{{ device.uniqueid }}<br>
										{{ device.iccid }}
									</td>
									<td>{{ device.vehicle_no }}<br><br>
										{{ device.dealer_name }}
									</td>
									<td>{{ $filters.formatDateTime(device.expirationtime) }}</td>
									<td>
										{{ device.enquired_dealer_first_name }}<br>
									</td>
									<td>
										<span v-if="device.is_enquiry == 1">
											{{ device.enquiry_on ? $filters.formatDateTime(device.enquiry_on) : '' }}<br>
											<b>{{ device.enquiry_by_name }}</b>
										</span>
									</td>
                                    <td>
										{{ device.requested_by_name }}<br>
										{{ device.requested_on ? $filters.formatDateTime(device.requested_on) : '' }}
									</td>
                                    <td>
										{{ device.recharged_by_name }}<br>
										{{ device.recharged_on ? $filters.formatDateTime(device.recharged_on) : '' }}
									</td>
                                    <td>
										{{ device.renewed_by_name }}<br>
										{{ device.renewed_on ? $filters.formatDateTime(device.renewed_on) : '' }}
									</td>
									<td>
										{{ device.paid_by_name }}<br>
										{{ device.payment_on ? $filters.formatDateTime(device.payment_on) : '' }}
									</td>
									<td>
										<span class="badge rounded-pill bg-primary" v-if="device.payment_type==1">Cash</span>
										<span class="badge rounded-pill bg-secondary" v-if="device.payment_type==2">Online</span>
										<span class="badge rounded-pill bg-success" v-if="device.payment_type==3">Both</span>
										<span class="badge rounded-pill bg-info" v-if="device.payment_type==4">Credit</span>
										<span v-if="!device.payment_type" class="text-muted">-</span>
									</td>
									<td>
										<template v-if="device.amount != null || device.cash_in_hand != null">
											Total: {{ device.amount }} <br> Cash: {{ device.cash_in_hand }} <br> Online: {{ device.cash_online }} <br> Credit: {{ device.credit_amount }} <br> Balance: {{ device.balance_amount }}
										</template>
										<span v-else class="text-muted">-</span>
									</td>
									<td>
										<span class="badge rounded-pill bg-success" v-if="device.payment_status==1">Received</span>
                                 		<span class="badge rounded-pill bg-danger" v-if="device.payment_status==2">Not Received</span>
										<span class="badge rounded-pill bg-warning" v-if="device.payment_status==3">Partially Received</span>
									</td>
                                    <td>
                                        <a class="btn btn-secondary btn-sm me-2 mb-2" @click="sendEnquiry(device)"  v-if="device.is_enquiry != 1 && device.request_status != 1">Enquiry</a>
										<router-link :to="{ name: 'recharge_device', params: { device_id: device.device_id } }" class="btn btn-warning btn-sm me-2 mb-2" v-if="(device.recharge_status == null && device.status == null) || (device.recharge_status == 2 && device.status != 4)">Request Recharge</router-link>
										<a class="btn btn-success btn-sm me-2 mb-2" @click="renewDevice(device)" v-if="device.renewal_status == 2 && device.recharge_status == 1">Renew</a>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.uniqueid} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
										<button class="btn btn-info btn-sm me-2 mb-2" type="button" data-original-title="test" v-if="device.renewal_status == 2" @click="safeCustody(device)">To Safe Custody</button>
										<router-link :to="{ name: 'device_extension', params: { device_id: device.device_id } }" class="btn btn-danger btn-sm me-2 mb-2" v-if="device.recharge_status == 2 && device.status != 4">Extension</router-link>
                                    </td>
								</tr>
								
							</tbody>

							<tbody v-else>
								<tr>
									<td colspan="13" align="center">No data available</td>
								</tr>
							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(renewal_devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchDeviceRenewal(buildQueryString(page.url))" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>  
					<!----pagination ends --->
                </div>

			</div>

			
		</div>

		<!-- Enquiry Modal -->
		<div class="modal fade" id="enquiryModal" tabindex="-1" aria-labelledby="enquiryModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="enquiryModalLabel">Enquiry</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitEnquiry" enctype="multipart/form-data">
							<!-- Device details -->
							<div class="row mb-1" v-if="enquiryDevice">
								<div class="col-md-12">
									<div class="alert alert-light border">
										<strong>Device:</strong> {{ enquiryDevice.uniqueid }}<br>
										<strong>Current Dealer:</strong> {{ enquiryDevice.dealer_name || '-' }}<br>
										<strong>Current Company:</strong> {{ enquiryDevice.company_name || '-' }}
									</div>
								</div>
							</div>

							<!-- Current Dealer (read-only, shown when device selected) -->
							<div class="row" v-if="enquiryDevice">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Current Dealer<span class="text-danger">*</span></label>
									<input 
										class="form-control" 
										type="text" 
										autocomplete="off"
										disabled
										:value="enquiryDevice.dealer_name || '-'"
									/>
								</div>
							</div>

							<!-- Renewal Type, Year Of Expiry, Amount -->
							<div class="row">
								<div class="col-md-4 form-group mb-2">
									<label class="control-label">Renewal Type</label>
									<select v-model="enquiryForm.renewal_type" class="form-select">
										<option value="">--select--</option>
										<option value="1">Normal</option>
										<option value="2">SIM Change</option>
										<option value="3">Replacement</option>
										<option value="4">Normal SIM Change</option>
									</select>
								</div>
								<div class="col-md-4 form-group mb-2">
									<label class="control-label">Year Of Expiry</label>
									<select v-model="enquiryForm.year_of_expiry" class="form-select">
										<option value="">--select--</option>
										<option value="1">1 Year</option>
										<option value="2">2 Year</option>
									</select>
								</div>
								<div class="col-md-4 form-group mb-2">
									<label class="control-label">Amount</label>
									<input class="form-control" type="number" placeholder="Enter Amount" v-model="enquiryForm.amount" />
								</div>
							</div>

							<div class="row">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Enquiry By<span class="text-danger">*</span></label>
									<select v-model="enquiryForm.enquiry_by" class="form-select" required @change="onEnquiryByChange">
										<option value="">Select</option>
										<option value="1">Dealer</option>
										<option value="2">Customer</option>
									</select>
								</div>
							</div>

							<div class="row" v-if="enquiryForm.enquiry_by == '1'">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Enquiry Dealer<span class="text-danger">*</span></label>
									<div class="position-relative">
										<input 
											class="form-control" 
											type="text" 
											placeholder="Search dealer..." 
											v-model="dealerSearch" 
											@input="searchDealer" 
											@focus="showDealerSuggestions = true" 
											@blur="hideDealerSuggestions"
											autocomplete="off"
										/>
										<ul v-if="showDealerSuggestions && filteredDealers.length" 
											class="list-group position-absolute w-100" 
											style="z-index: 10; max-height: 200px; overflow-y: auto;">
											<li v-for="dealer in filteredDealers" 
												:key="dealer.id" 
												class="list-group-item list-group-item-action" 
												@mousedown.prevent="selectDealer(dealer)">
												{{ dealer.first_name }} {{ dealer.last_name }}
											</li>
										</ul>
									</div>
									<div v-if="enquiryForm.selectedDealer" class="mt-2">
										<small class="text-success">
											<i class="icofont icofont-check-circled me-1"></i>
											Selected: <strong>{{ enquiryForm.selectedDealer.first_name }} {{ enquiryForm.selectedDealer.last_name }}</strong>
										</small>
									</div>
									<span v-if="errors.dealer_id" class="text-danger small">{{ errors.dealer_id }}</span>
								</div>
							</div>

							<div class="row" v-if="enquiryForm.enquiry_by == '1'">
								<div class="col-md-12 form-group mb-2">
									<div class="form-check">
										<input type="checkbox" class="form-check-input" id="assignToThisDealer" v-model="enquiryForm.assignToThisDealer" />
										<label class="form-check-label" for="assignToThisDealer">Assign to this dealer</label>
									</div>
								</div>
							</div>

							<!-- Customer selection - existing -->
							<div class="row" v-if="enquiryForm.enquiry_by == '2' && !enquiryForm.isNewCustomer">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Customer<span class="text-danger">*</span></label>
									<div class="position-relative">
										<input 
											class="form-control" 
											type="text" 
											placeholder="Search customer..." 
											v-model="customerSearch" 
											@input="searchCustomer" 
											@focus="showCustomerSuggestions = true" 
											@blur="hideCustomerSuggestions"
											autocomplete="off"
										/>
										<ul v-if="showCustomerSuggestions && filteredCustomers.length" 
											class="list-group position-absolute w-100" 
											style="z-index: 10; max-height: 200px; overflow-y: auto;">
											<li v-for="cust in filteredCustomers" 
												:key="cust.id" 
												class="list-group-item list-group-item-action" 
												@mousedown.prevent="selectCustomer(cust)">
												{{ cust.company_name }} - <b>{{ cust.mobile }}</b>
											</li>
										</ul>
									</div>
									<div v-if="enquiryForm.selectedCustomer" class="mt-2">
										<small class="text-success">
											<i class="icofont icofont-check-circled me-1"></i>
											Selected: <strong>{{ enquiryForm.selectedCustomer.company_name }}</strong>
										</small>
									</div>
									<div class="mt-2">
										<a href="#" class="small" @click.prevent="enquiryForm.isNewCustomer = true">+ Add new customer</a>
									</div>
									<span v-if="errors.company_id" class="text-danger small">{{ errors.company_id }}</span>
								</div>
							</div>

							<!-- Customer - new (add new customer) -->
							<div class="row" v-if="enquiryForm.enquiry_by == '2' && enquiryForm.isNewCustomer">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Customer Name<span class="text-danger">*</span></label>
									<input v-model="enquiryForm.customer_name" class="form-control" placeholder="Enter customer name" />
									<span v-if="errors.customer_name" class="text-danger small">{{ errors.customer_name }}</span>
								</div>
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Username<span class="text-danger">*</span></label>
									<input v-model="enquiryForm.username" class="form-control" placeholder="Enter username" />
									<span v-if="errors.username" class="text-danger small">{{ errors.username }}</span>
								</div>
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Password<span class="text-danger">*</span></label>
									<input v-model="enquiryForm.password" type="password" class="form-control" placeholder="Enter password" />
									<span v-if="errors.password" class="text-danger small">{{ errors.password }}</span>
								</div>
								<div class="col-md-12">
									<a href="#" class="small" @click.prevent="enquiryForm.isNewCustomer = false; clearNewCustomerFields()">← Select existing customer</a>
								</div>
							</div>

							<div class="row" v-if="enquiryForm.enquiry_by == '2'">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Vehicle No.</label>
									<input
										class="form-control"
										type="text"
										v-model="enquiryForm.vehicle_no"
										:disabled="enquiryVehicleNoLocked"
										placeholder="Enter vehicle number"
										autocomplete="off"
									/>
									<small v-if="enquiryVehicleNoLocked" class="text-muted">From device record (read-only)</small>
									<span v-if="errors.vehicle_no" class="text-danger small d-block mt-1">{{ Array.isArray(errors.vehicle_no) ? errors.vehicle_no[0] : errors.vehicle_no }}</span>
								</div>
							</div>

							<div class="row mt-3">
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary me-2" :disabled="enquirySubmitting">
										<span v-if="enquirySubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										{{ enquirySubmitting ? "Saving..." : "Submit Enquiry" }}
									</button>
									<button type="button" class="btn btn-light" @click="closeEnquiryModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- Mark payment received (same flow as pending payments) -->
		<div class="modal fade" id="paymentModalRenewal" tabindex="-1" aria-labelledby="paymentModalRenewalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="paymentModalRenewalLabel">Mark Payment Received</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="paymentModalDevice && paymentModalDevice.payment_status == 3" class="alert alert-warning mb-3">
							<h6 class="alert-heading">Partial payment details</h6>
							<p class="mb-1">Total: {{ paymentModalDevice.amount }}</p>
							<p class="mb-1">Cash paid: {{ paymentModalDevice.cash_in_hand || 0 }}</p>
							<p class="mb-1">Online paid: {{ paymentModalDevice.cash_online || 0 }}</p>
							<p v-if="paymentModalDevice.payment_id" class="mb-1 text-muted small">Payment ID: {{ paymentModalDevice.payment_id }}</p>
							<hr>
							<p class="mb-0 fw-bold">Balance due: {{ balanceDue }}</p>
						</div>

						<form @submit.prevent="submitPaymentComplete">
							<div class="row">
								<div class="col-12">
									<div class="form-group mb-3">
										<label class="control-label">Payment By<span class="text-danger">*</span></label>
										<select class="form-select" v-model="paymentForm.payment_by" @change="onPaymentByChange" :class="{ 'is-invalid': errors.payment_by }">
											<option value="">--Select Payment By--</option>
											<option value="1">Dealer</option>
											<option value="2">Customer</option>
										</select>
										<div v-if="errors.payment_by" class="invalid-feedback">{{ errors.payment_by }}</div>
									</div>
								</div>

								<div class="col-12" v-if="paymentForm.payment_by == '1'">
									<div class="form-group mb-3">
										<label class="control-label">Payment Dealer<span class="text-danger">*</span></label>
										<div class="position-relative">
											<input
												class="form-control"
												type="text"
												placeholder="Search dealer..."
												v-model="paymentDealerSearch"
												@input="searchPaymentDealer"
												@focus="showPaymentDealerSuggestions = true"
												@blur="hidePaymentDealerSuggestions"
												autocomplete="off"
												:class="{ 'is-invalid': errors.payment_user_id }"
											/>
											<ul
												v-if="showPaymentDealerSuggestions && filteredPaymentDealers.length"
												class="list-group position-absolute w-100"
												style="z-index: 10; max-height: 200px; overflow-y: auto;"
											>
												<li
													v-for="dealer in filteredPaymentDealers"
													:key="dealer.id"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="selectPaymentDealer(dealer)"
												>
													{{ dealer.first_name }} {{ dealer.last_name }}
												</li>
											</ul>
										</div>
										<div v-if="selectedPaymentDealer" class="mt-2">
											<small class="text-success">
												<i class="icofont icofont-check-circled me-1"></i>
												Selected: <strong>{{ selectedPaymentDealer.first_name }} {{ selectedPaymentDealer.last_name }}</strong>
											</small>
										</div>
										<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
									</div>
								</div>
								<div class="col-12" v-if="paymentForm.payment_by == '2'">
									<div class="form-group mb-3">
										<label class="control-label">Customer<span class="text-danger">*</span></label>
										<div class="position-relative">
											<input
												class="form-control"
												type="text"
												placeholder="Search customer..."
												v-model="paymentCustomerSearch"
												@input="searchPaymentCustomer"
												@focus="showPaymentCustomerSuggestions = true"
												@blur="hidePaymentCustomerSuggestions"
												autocomplete="off"
												:class="{ 'is-invalid': errors.payment_user_id }"
											/>
											<ul
												v-if="showPaymentCustomerSuggestions && filteredPaymentCustomers.length"
												class="list-group position-absolute w-100"
												style="z-index: 10; max-height: 200px; overflow-y: auto;"
											>
												<li
													v-for="cust in filteredPaymentCustomers"
													:key="cust.id"
													class="list-group-item list-group-item-action"
													@mousedown.prevent="selectPaymentCustomer(cust)"
												>
													{{ cust.company_name }}
												</li>
											</ul>
										</div>
										<div v-if="selectedPaymentCustomer" class="mt-2">
											<small class="text-success">
												<i class="icofont icofont-check-circled me-1"></i>
												Selected: <strong>{{ selectedPaymentCustomer.company_name }}</strong>
											</small>
										</div>
										<div v-if="errors.payment_user_id" class="invalid-feedback d-block">{{ errors.payment_user_id }}</div>
									</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id">
								<div class="col-12">
									<div class="form-group mb-3">
										<label class="control-label">Payment Type<span class="text-danger">*</span></label>
										<select class="form-select" v-model="paymentForm.payment_type" @change="onPaymentTypeChange" :class="{ 'is-invalid': errors.payment_type }">
											<option value="">--Select Payment Type--</option>
											<option value="1">Cash</option>
											<option value="2">Online</option>
											<option value="3">Both</option>
											<option value="4">Credit</option>
										</select>
										<div v-if="errors.payment_type" class="invalid-feedback">{{ errors.payment_type }}</div>
									</div>
								</div>
								<div class="col-12" v-if="paymentForm.payment_type == '2' || paymentForm.payment_type == '3'">
									<div class="form-group mb-3">
										<label class="control-label">Select Bank<span class="text-danger">*</span></label>
										<select
											class="form-select"
											v-model="paymentForm.bank_account_id"
											:class="{ 'is-invalid': errors.bank_account_id }"
										>
											<option value="">--Select Bank--</option>
											<option v-for="bank in banks" :key="bank.id" :value="bank.id">
												{{ bank.bank_name }} ({{ bank.account_number }})
											</option>
										</select>
										<div v-if="errors.bank_account_id" class="invalid-feedback">{{ errors.bank_account_id }}</div>
									</div>
								</div>
								<div class="col-12" v-if="showUserCredit">
									<div class="form-group mb-3">
										<label class="control-label">Amount from credit<span class="text-danger">*</span></label>
										<input
											class="form-control"
											type="number"
											step="0.01"
											min="0"
											placeholder="Enter credit amount"
											v-model="paymentForm.amount_from_credit"
											:class="{ 'is-invalid': errors.amount_from_credit }"
										/>
										<div v-if="userCreditLoading" class="mt-2">
											<small class="text-success">Loading...</small>
										</div>
										<div v-else-if="userCredit && userCredit.credit_available_amount != null" class="mt-2">
											<small class="text-success">Credit available: ₹{{ userCredit.credit_available_amount }}</small>
										</div>
										<div v-else class="mt-2">
											<small class="text-muted">-</small>
										</div>
										<div v-if="errors.amount_from_credit" class="invalid-feedback d-block">{{ errors.amount_from_credit }}</div>
										<div v-if="userCreditError" class="text-danger small mt-1">{{ userCreditError }}</div>
									</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id && (paymentForm.payment_type == '2' || paymentForm.payment_type == '3')">
								<div class="col-12 mb-3">
									<label class="control-label">Online Amount<span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter online amount" v-model="paymentForm.cash_online" :class="{ 'is-invalid': errors.cash_online }"/>
									<div v-if="errors.cash_online" class="invalid-feedback d-block">{{ errors.cash_online }}</div>
								</div>
								<div class="col-12 mb-3">
									<label class="control-label">Payment ID<span class="text-danger">*</span></label>
									<input class="form-control" type="text" placeholder="Enter payment ID" v-model="paymentForm.payment_id" :class="{ 'is-invalid': errors.payment_id }"/>
									<div v-if="errors.payment_id" class="invalid-feedback d-block">{{ errors.payment_id }}</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_user_id && (paymentForm.payment_type == '1' || paymentForm.payment_type == '3')">
								<div class="col-12 mb-3">
									<label class="control-label">Cash Amount<span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Enter cash amount" v-model="paymentForm.cash_in_hand" :class="{ 'is-invalid': errors.cash_in_hand }"/>
									<div v-if="errors.cash_in_hand" class="invalid-feedback d-block">{{ errors.cash_in_hand }}</div>
								</div>
							</div>

							<div class="row" v-if="paymentBreakdown">
								<div class="col-12">
									<div class="card border-light">
										<div class="card-body p-2">
											<div class="row text-center">
												<div class="col-6 col-md-3">
													<small class="text-muted">Total Amount</small>
													<div class="fw-bold">₹{{ paymentBreakdown.total }}</div>
												</div>
												<div class="col-6 col-md-3" v-if="paymentForm.payment_type === '2' || paymentForm.payment_type === '3'">
													<small class="text-muted">Online</small>
													<div class="fw-bold">₹{{ paymentBreakdown.online }}</div>
												</div>
												<div class="col-6 col-md-3" v-if="paymentForm.payment_type === '1' || paymentForm.payment_type === '3'">
													<small class="text-muted">Cash</small>
													<div class="fw-bold">₹{{ paymentBreakdown.cash }}</div>
												</div>
												<div class="col-6 col-md-3">
													<small class="text-muted">Balance due</small>
													<div class="fw-bold" :class="parseFloat(balanceDue) > 0 ? 'text-warning' : 'text-success'">
														₹{{ balanceDue }}
													</div>
												</div>
												<div class="col-6 col-md-3">
													<small class="text-muted">Status</small>
													<div class="fw-bold" :class="paymentBreakdown.statusClass">
														{{ paymentBreakdown.statusLabel }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="modal-footer px-0 pb-0">
								<button type="button" class="btn btn-light" @click="closePaymentModal">Close</button>
								<button type="submit" class="btn btn-primary" :disabled="paymentSubmitting">
									<span v-if="paymentSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									{{ paymentSubmitting ? "Saving..." : "Submit" }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
   </div>
</template>


<script>
import { Modal } from 'bootstrap'

	export default {
		name: "Device Renewal",
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2024-01-01')
			const maxDate = new Date().toISOString().slice(0, 10) // Format: YYYY-MM-DD

			return {
				end_date: new Date().toISOString().slice(0, 10),
				start_date: '',
				pagination: {},
				keyword: "",
				listing_length: 20,
				token: "",
				imei: '',
				searchTimeout: null,
				all_renewal_devices: [],
				renewal_devices: [],

				max: maxDate,

				enquiry_status: { id: "" },
				renew_status: { id: "" },
				safe_custody: { imei: "" },

				excel: { loading: false },
				pdf: { loading: false },
				errors: {},

				// Enquiry modal
				enquiryModalInstance: null,
				enquiryDevice: null,
				enquiryForm: {
					enquiry_by: '',
					renewal_type: '',
					year_of_expiry: '',
					amount: '',
					vehicle_no: '',
					selectedDealer: null,
					selectedCustomer: null,
					isNewCustomer: false,
					assignToThisDealer: false,
					customer_name: '',
					username: '',
					password: ''
				},
				dealers: [],
				companies: [],
				dealerSearch: '',
				customerSearch: '',
				showDealerSuggestions: false,
				showCustomerSuggestions: false,
				enquirySubmitting: false,
				count: 0,

				active_page_url: '',

				// Mark payment received modal
				paymentModalInstance: null,
				paymentModalDevice: null,
				paymentForm: {
					payment_type: '',
					payment_by: '',
					payment_user_id: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				},
				paymentSubmitting: false,
				userCredit: null,
				userCreditLoading: false,
				userCreditError: '',
				prevShowUserCredit: false,
				paymentDealerSearch: '',
				showPaymentDealerSuggestions: false,
				selectedPaymentDealer: null,
				paymentCustomerSearch: '',
				showPaymentCustomerSuggestions: false,
				selectedPaymentCustomer: null,
				banks: [],
				
			};
		},

		mounted() {
			const el = document.getElementById('enquiryModal');
			if (el) this.enquiryModalInstance = new Modal(el);
			const payEl = document.getElementById('paymentModalRenewal');
			if (payEl) this.paymentModalInstance = new Modal(payEl);
			this.getToken();
			this.fetchDealers();
			this.fetchCompanies();
			this.fetchBankAccounts();
		},

		computed: {
			filteredDealers() {
				if (!this.dealerSearch.trim()) return this.dealers;
				const q = this.dealerSearch.toLowerCase();
				return this.dealers.filter(d => (d.first_name || '').toLowerCase().includes(q));
			},
			filteredCustomers() {
				if (!this.customerSearch.trim()) return this.companies;
				const q = this.customerSearch.toLowerCase();
				return this.companies.filter(c => (c.company_name || '').toLowerCase().includes(q));
			},
			enquiryVehicleNoLocked() {
				if (!this.enquiryDevice) return false;
				const v = this.enquiryDevice.vehicle_no;
				return v != null && String(v).trim() !== '';
			},
			balanceDue() {
				if (!this.paymentModalDevice) return '0.00';
				const amount = parseFloat(this.paymentModalDevice.amount) || 0;
				const cash = parseFloat(this.paymentModalDevice.cash_in_hand) || 0;
				const online = parseFloat(this.paymentModalDevice.cash_online) || 0;
				const credit = parseFloat(this.paymentModalDevice.credit_amount) || 0;
				const balance = amount - cash - online - credit;
				return (isNaN(balance) ? 0 : balance).toFixed(2);
			},
			creditCapNumeric() {
				if (!this.paymentModalDevice) return NaN;
				if (Number(this.paymentModalDevice.payment_status) === 3) {
					return parseFloat(this.balanceDue) || 0;
				}
				return parseFloat(this.paymentModalDevice.amount) || 0;
			},
			showUserCredit() {
				return !!this.paymentForm.payment_user_id && this.paymentForm.payment_type === '4';
			},
			paymentBreakdown() {
				if (!this.paymentModalDevice || !this.paymentForm.payment_type || this.paymentForm.payment_type === '4') return null;

				const total = parseFloat(this.paymentModalDevice.amount) || 0;
				const online = parseFloat(this.paymentForm.cash_online) || 0;
				const cash = parseFloat(this.paymentForm.cash_in_hand) || 0;
				const outstanding = parseFloat(this.balanceDue) || 0;

				let paid = 0;
				if (this.paymentForm.payment_type === '2') {
					paid = online;
				} else if (this.paymentForm.payment_type === '3') {
					paid = online + cash;
				} else if (this.paymentForm.payment_type === '1') {
					paid = cash;
				} else {
					return null;
				}

				const eps = 0.01;
				const diff = paid - outstanding;
				let statusLabel = 'Partial';
				let statusClass = 'text-warning';
				if (Math.abs(diff) < eps) {
					statusLabel = 'Full';
					statusClass = 'text-success';
				} else if (diff > eps) {
					statusLabel = 'Advance';
					statusClass = 'text-info';
				}

				if (this.paymentForm.payment_type === '2') {
					return { total, online, cash: 0, statusLabel, statusClass };
				}
				if (this.paymentForm.payment_type === '3') {
					return { total, online, cash, statusLabel, statusClass };
				}
				return { total, online: 0, cash, statusLabel, statusClass };
			},
			filteredPaymentDealers() {
				if (!this.paymentDealerSearch.trim()) return this.dealers;
				const q = this.paymentDealerSearch.toLowerCase();
				return this.dealers.filter(d => (d.first_name || '').toLowerCase().includes(q));
			},
			filteredPaymentCustomers() {
				if (!this.paymentCustomerSearch.trim()) return this.companies;
				const q = this.paymentCustomerSearch.toLowerCase();
				return this.companies.filter(c => (c.company_name || '').toLowerCase().includes(q));
			},
		},

		created() {
			// Read IMEI from route query parameters if present
			if (this.$route.query.imei) {
				this.imei = this.$route.query.imei;
			}
			this.fetchDeviceRenewal();
		},

		watch: {
			'paymentForm.payment_user_id': 'maybeFetchUserCredit',
			'paymentForm.payment_type': 'maybeFetchUserCredit',
			'$route.query.imei'(newImei) {
				if (newImei) {
					this.imei = newImei;
					this.fetchDeviceRenewal();
				}
			},
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			applyApiValidationErrors(apiData) {
				const message = apiData?.message;
				const errors = apiData?.errors;
				if (message && typeof message === "object" && !Array.isArray(message)) {
					this.errors = message;
					return;
				}
				if (errors && typeof errors === "object" && !Array.isArray(errors)) {
					this.errors = errors;
				}
			},

			getApiErrorMessage(apiData, fallback = "Failed to submit enquiry") {
				const pickFirst = (obj) => {
					if (!obj || typeof obj !== "object") return "";
					const firstKey = Object.keys(obj)[0];
					if (!firstKey) return "";
					const value = obj[firstKey];
					if (Array.isArray(value)) return value[0] || "";
					if (typeof value === "string") return value;
					return "";
				};

				if (typeof apiData?.message === "string" && apiData.message.trim()) return apiData.message;
				if (apiData?.message && typeof apiData.message === "object") {
					const msg = pickFirst(apiData.message);
					if (msg) return msg;
				}
				if (apiData?.errors && typeof apiData.errors === "object") {
					const msg = pickFirst(apiData.errors);
					if (msg) return msg;
				}
				return fallback;
			},

			onImeiSearch() {
				if (this.searchTimeout) clearTimeout(this.searchTimeout);
				this.searchTimeout = setTimeout(() => {
					this.fetchDeviceRenewal();
					this.searchTimeout = null;
				}, 500);
			},

			buildQueryString(baseUrl = null) {
				// Build query parameters
				const params = new URLSearchParams();
				params.append('limit', this.listing_length);
				if (this.imei && this.imei.trim()) {
					params.append('imei', this.imei.trim());
				}
				if (this.start_date) {
					params.append('from_date', this.start_date);
				}
				if (this.end_date) {
					params.append('to_date', this.end_date);
				}

				if (baseUrl) {
					// If baseUrl already has query params, append to it
					const separator = baseUrl.includes('?') ? '&' : '?';
					return baseUrl + separator + params.toString();
				}
				return "/staffs/renewalDevices?" + params.toString();
			},

			fetchDeviceRenewal(page_url = null) {
				this.getToken();
				// Build URL with IMEI parameter if present
				let url = this.buildQueryString();
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.renewal_devices = responseData.renewal_devices.data;
						this.pagination = responseData.renewal_devices.links;
						this.from = responseData.renewal_devices.from;
						this.to = responseData.renewal_devices.to;
						this.total = responseData.renewal_devices.total;
						this.count = responseData.count;
						console.log(this.count);
					})
					.catch((err) => console.log(err));
			},
			


			sendEnquiry(device) {
				this.enquiryDevice = device;
				this.enquiryForm.enquiry_by = '';
				this.enquiryForm.renewal_type = '';
				this.enquiryForm.year_of_expiry = '';
				this.enquiryForm.amount = '';
				this.enquiryForm.vehicle_no = '';
				this.syncEnquiryVehicleNoFromDevice();
				this.enquiryForm.selectedDealer = null;
				this.enquiryForm.selectedCustomer = null;
				this.enquiryForm.isNewCustomer = false;
				this.enquiryForm.assignToThisDealer = false;
				this.clearNewCustomerFields();
				this.dealerSearch = '';
				this.customerSearch = '';
				this.errors = {};

				// Fetch both dealers and companies, then apply auto-selection
				Promise.all([this.fetchDealers(), this.fetchCompanies()]).then(() => {
					// Auto-select will be applied when user selects enquiry_by in onEnquiryByChange
					// Pre-select first option if device has data
					if (device.dealer_id) {
						const dealer = this.dealers.find(d => d.id == device.dealer_id);
						if (dealer) {
							this.enquiryForm.selectedDealer = dealer;
							this.dealerSearch = dealer.first_name;
						}
					}
					if (device.company_id) {
						const cust = this.companies.find(c => c.id == device.company_id);
						if (cust) {
							this.enquiryForm.selectedCustomer = cust;
							this.customerSearch = cust.company_name;
						}
					}
				});

				if (this.enquiryModalInstance) this.enquiryModalInstance.show();
			},

			fetchDealers() {
				this.getToken();
				return this.$axios
					.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.dealers = Array.isArray(data) ? data : (data.data || []);
						return this.dealers;
					})
					.catch((err) => {
						console.log(err);
						this.dealers = [];
						return [];
					});
			},

			fetchCompanies() {
				this.getToken();
				return this.$axios
					.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.companies = Array.isArray(data) ? data : (data.data || []);
						return this.companies;
					})
					.catch((err) => {
						console.log(err);
						this.companies = [];
						return [];
					});
			},

			fetchBankAccounts() {
				this.getToken();
				return this.$axios
					.get("/staffs/bankAccounts", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						const data = res.data.data || res.data;
						this.banks = Array.isArray(data) ? data : (data.data || []);
					})
					.catch(() => {
						this.banks = [];
					});
			},

			getSelectedUserId(entity) {
				return entity && entity.user_id ? entity.user_id : '';
			},

			openPaymentModal(device) {
				this.getToken();
				this.paymentModalDevice = device;
				this.userCredit = null;
				this.userCreditError = '';
				this.userCreditLoading = false;
				this.prevShowUserCredit = false;
				this.paymentForm = {
					payment_type: '',
					payment_by: '1',
					payment_user_id: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				};
				this.paymentDealerSearch = '';
				this.selectedPaymentDealer = null;
				this.paymentCustomerSearch = '';
				this.selectedPaymentCustomer = null;
				this.showPaymentDealerSuggestions = false;
				this.showPaymentCustomerSuggestions = false;
				this.errors = {};

				const dealerId = device?.dealer_id != null ? device.dealer_id : null;
				if (dealerId != null) {
					const dealer = this.dealers.find(
						(d) => d.id == dealerId || String(d.id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || '';
						this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = device?.dealer_name || '';
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: device?.dealer_name || '',
							user_id: device?.dealer_user_id || '',
						};
						this.paymentForm.payment_user_id =
							device?.dealer_user_id != null && device?.dealer_user_id !== ''
								? String(device.dealer_user_id)
								: '';
					}
				}

				if (this.paymentModalInstance) this.paymentModalInstance.show();
			},

			closePaymentModal() {
				if (this.paymentModalInstance) this.paymentModalInstance.hide();
				this.paymentModalDevice = null;
				this.userCredit = null;
				this.userCreditError = '';
				this.prevShowUserCredit = false;
				this.paymentForm = {
					payment_type: '',
					payment_by: '',
					payment_user_id: '',
					bank_account_id: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
					amount_from_credit: '',
				};
				this.errors = {};
			},

			onPaymentByChange() {
				this.paymentForm.payment_user_id = '';
				this.paymentForm.payment_type = '';
				this.paymentForm.amount_from_credit = '';
				this.paymentForm.bank_account_id = '';
				this.selectedPaymentDealer = null;
				this.selectedPaymentCustomer = null;
				this.paymentDealerSearch = '';
				this.paymentCustomerSearch = '';
				this.errors.payment_user_id = '';
				this.userCredit = null;
				this.userCreditError = '';

				if (this.paymentForm.payment_by === '1' && this.paymentModalDevice?.dealer_id != null) {
					const dealerId = this.paymentModalDevice.dealer_id;
					const dealer = this.dealers.find(
						(d) => d.id == dealerId || String(d.id) === String(dealerId)
					);
					if (dealer) {
						this.selectedPaymentDealer = dealer;
						this.paymentDealerSearch = dealer.first_name || '';
						this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
					} else {
						this.paymentDealerSearch = this.paymentModalDevice?.dealer_name || '';
						this.selectedPaymentDealer = {
							id: dealerId,
							first_name: this.paymentModalDevice?.dealer_name || '',
							user_id: this.paymentModalDevice?.dealer_user_id || '',
						};
						this.paymentForm.payment_user_id =
							this.paymentModalDevice?.dealer_user_id != null &&
							this.paymentModalDevice?.dealer_user_id !== ''
								? String(this.paymentModalDevice.dealer_user_id)
								: '';
					}
				}
			},

			onPaymentTypeChange() {
				if (this.paymentForm.payment_type === '2') {
					this.paymentForm.cash_in_hand = '';
				} else if (this.paymentForm.payment_type === '1') {
					this.paymentForm.cash_online = '';
					this.paymentForm.payment_id = '';
				} else if (this.paymentForm.payment_type === '4') {
					this.paymentForm.cash_in_hand = '';
					this.paymentForm.cash_online = '';
					this.paymentForm.payment_id = '';
				}
				if (!(this.paymentForm.payment_type === '2' || this.paymentForm.payment_type === '3')) {
					this.paymentForm.bank_account_id = '';
				}
				if (this.paymentForm.payment_type !== '4') {
					this.paymentForm.amount_from_credit = '';
				}
			},

			async maybeFetchUserCredit() {
				const nowVisible = this.showUserCredit;
				const wasVisible = this.prevShowUserCredit;

				if (!nowVisible) {
					this.userCredit = null;
					this.userCreditError = '';
					this.userCreditLoading = false;
					this.paymentForm.amount_from_credit = '';
					this.prevShowUserCredit = nowVisible;
					return;
				}
				if (!this.paymentForm.payment_user_id) return;

				if (!wasVisible) {
					const cap = this.creditCapNumeric;
					this.paymentForm.amount_from_credit =
						!isNaN(cap) && cap > 0 ? String(cap) : this.paymentModalDevice?.amount || '';
					this.errors.amount_from_credit = '';
				}

				await this.fetchUserCredit();
				this.prevShowUserCredit = nowVisible;
			},

			async fetchUserCredit() {
				try {
					this.getToken();
					this.userCreditLoading = true;
					this.userCreditError = '';

					const response = await this.$axios.get('/staffs/getUserCredit', {
						params: { user_id: this.paymentForm.payment_user_id },
						headers: { Authorization: `Bearer ${this.token}` },
					});

					const ok = response.data?.status === true || response.data?.status === 'true';
					if (!ok) {
						this.userCredit = null;
						this.userCreditError = response.data?.message || 'Failed to fetch credit balance';
						return;
					}

					this.userCredit = response.data?.data?.user_credit || null;
				} catch (e) {
					this.userCredit = null;
					this.userCreditError = e?.response?.data?.message || 'Failed to fetch credit balance';
				} finally {
					this.userCreditLoading = false;
				}
			},

			searchPaymentDealer() {
				this.showPaymentDealerSuggestions = true;
			},
			hidePaymentDealerSuggestions() {
				setTimeout(() => { this.showPaymentDealerSuggestions = false; }, 200);
			},
			selectPaymentDealer(dealer) {
				this.selectedPaymentDealer = dealer;
				this.paymentDealerSearch = dealer.first_name;
				this.showPaymentDealerSuggestions = false;
				this.paymentForm.payment_user_id = this.getSelectedUserId(dealer);
				this.errors.payment_user_id = '';
			},

			searchPaymentCustomer() {
				this.showPaymentCustomerSuggestions = true;
			},
			hidePaymentCustomerSuggestions() {
				setTimeout(() => { this.showPaymentCustomerSuggestions = false; }, 200);
			},
			selectPaymentCustomer(cust) {
				this.selectedPaymentCustomer = cust;
				this.paymentCustomerSearch = cust.company_name;
				this.showPaymentCustomerSuggestions = false;
				this.paymentForm.payment_user_id = this.getSelectedUserId(cust);
				this.errors.payment_user_id = '';
			},

			submitPaymentComplete() {
				this.getToken();
				this.errors = {};

				if (!this.paymentForm.payment_by) {
					this.errors.payment_by = 'Please select payment by.';
				}
				if (!this.paymentForm.payment_user_id) {
					this.errors.payment_user_id = 'Please select payment user.';
				}

				const pt = this.paymentForm.payment_type;
				if (!pt) {
					this.errors.payment_type = 'Payment type is required.';
				} else if (pt === '2') {
					if (!this.paymentForm.cash_online || parseFloat(this.paymentForm.cash_online) <= 0) {
						this.errors.cash_online = 'Online amount is required.';
					}
					if (!this.paymentForm.bank_account_id) {
						this.errors.bank_account_id = 'Bank account is required for online payment.';
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
					}
				} else if (pt === '1') {
					if (!this.paymentForm.cash_in_hand || parseFloat(this.paymentForm.cash_in_hand) <= 0) {
						this.errors.cash_in_hand = 'Cash amount is required.';
					}
				} else if (pt === '3') {
					if (!this.paymentForm.cash_online || parseFloat(this.paymentForm.cash_online) <= 0) {
						this.errors.cash_online = 'Online amount is required.';
					}
					if (!this.paymentForm.cash_in_hand || parseFloat(this.paymentForm.cash_in_hand) <= 0) {
						this.errors.cash_in_hand = 'Cash amount is required.';
					}
					if (!this.paymentForm.bank_account_id) {
						this.errors.bank_account_id = 'Bank account is required for online/both payment.';
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
					}
				}

				if (this.showUserCredit) {
					const creditAmt = parseFloat(this.paymentForm.amount_from_credit);
					if (!this.paymentForm.amount_from_credit || isNaN(creditAmt) || creditAmt <= 0) {
						this.errors.amount_from_credit = 'Amount from credit is required.';
					} else {
						if (this.userCredit && this.userCredit.credit_available_amount != null) {
							const available = parseFloat(this.userCredit.credit_available_amount);
							if (!isNaN(available) && creditAmt > available) {
								this.errors.amount_from_credit = 'Amount from credit cannot exceed available credit.';
							}
						}
						const cap = this.creditCapNumeric;
						if (!isNaN(cap) && cap >= 0 && creditAmt > cap) {
							this.errors.amount_from_credit = 'Amount from credit cannot exceed the payable amount.';
						}
					}
				}

				if (Object.keys(this.errors).length) return;
				if (this.paymentSubmitting) return;

				this.paymentSubmitting = true;

				const payload = {
					device_id: this.paymentModalDevice.id,
					payment_type: parseInt(pt, 10),
					bank_account_id: '',
					payment_id: '',
					cash_in_hand: 0,
					cash_online: 0,
					amount_from_credit: this.showUserCredit
						? (this.paymentForm.amount_from_credit ? parseFloat(this.paymentForm.amount_from_credit) : 0)
						: 0,
				};

				if (this.paymentForm.payment_by && this.paymentForm.payment_user_id) {
					payload.payment_user_type = this.paymentForm.payment_by;
					payload.payment_user_id = this.paymentForm.payment_user_id;
				}

				if (pt === '2' || pt === '3') {
					payload.bank_account_id = this.paymentForm.bank_account_id;
					payload.cash_online = parseFloat(this.paymentForm.cash_online) || 0;
					payload.payment_id = String(this.paymentForm.payment_id).trim();
				}
				if (pt === '1' || pt === '3') {
					payload.cash_in_hand = parseFloat(this.paymentForm.cash_in_hand) || 0;
				}

				this.$axios
					.post('/staffs/paymentComplete', payload, { headers: { Authorization: 'Bearer ' + this.token } })
					.then((response) => {
						this.paymentSubmitting = false;
						if (response.data.status) {
							this.$swal('', response.data.message || 'Payment recorded successfully.', 'success');
							this.closePaymentModal();
							this.fetchDeviceRenewal(this.active_page_url);
						} else {
							this.$swal('', response.data.message || 'Failed to record payment.', 'error');
						}
					})
					.catch((error) => {
						this.paymentSubmitting = false;
						const msg = error.response && error.response.data && error.response.data.message
							? error.response.data.message
							: (error.response && error.response.data && error.response.data.errors
								? Object.values(error.response.data.errors).flat().join(' ')
								: 'Something went wrong.');
						this.$swal('', msg, 'error');
						if (error.response && error.response.data && error.response.data.errors) {
							const errs = error.response.data.errors;
							this.errors = Object.keys(errs).reduce((acc, k) => {
								acc[k] = Array.isArray(errs[k]) ? errs[k][0] : errs[k];
								return acc;
							}, {});
						}
					});
			},

			searchDealer() {
				this.showDealerSuggestions = true;
			},
			searchCustomer() {
				this.showCustomerSuggestions = true;
			},
			hideDealerSuggestions() {
				setTimeout(() => { this.showDealerSuggestions = false; }, 200);
			},
			hideCustomerSuggestions() {
				setTimeout(() => { this.showCustomerSuggestions = false; }, 200);
			},
			selectDealer(dealer) {
				this.enquiryForm.selectedDealer = dealer;
				this.dealerSearch = dealer.first_name;
				this.showDealerSuggestions = false;
			},
			selectCustomer(cust) {
				this.enquiryForm.selectedCustomer = cust;
				this.customerSearch = cust.company_name;
				this.showCustomerSuggestions = false;
			},

			onEnquiryByChange() {
				this.enquiryForm.selectedDealer = null;
				this.enquiryForm.selectedCustomer = null;
				this.enquiryForm.isNewCustomer = false;
				this.enquiryForm.assignToThisDealer = false;
				this.dealerSearch = '';
				this.customerSearch = '';
				this.clearNewCustomerFields();
				// Re-apply auto-selection based on device
				if (this.enquiryDevice) {
					if (this.enquiryForm.enquiry_by == '1' && this.enquiryDevice.dealer_id) {
						const dealer = this.dealers.find(d => d.id == this.enquiryDevice.dealer_id);
						if (dealer) {
							this.enquiryForm.selectedDealer = dealer;
							this.dealerSearch = dealer.first_name;
						}
					}
					if (this.enquiryForm.enquiry_by == '2' && this.enquiryDevice.company_id) {
						const cust = this.companies.find(c => c.id == this.enquiryDevice.company_id);
						if (cust) {
							this.enquiryForm.selectedCustomer = cust;
							this.customerSearch = cust.company_name;
						}
					}
				}
				if (this.enquiryForm.enquiry_by == '2') {
					this.syncEnquiryVehicleNoFromDevice();
				} else {
					this.enquiryForm.vehicle_no = '';
				}
			},

			syncEnquiryVehicleNoFromDevice() {
				if (!this.enquiryDevice) {
					this.enquiryForm.vehicle_no = '';
					return;
				}
				const v = this.enquiryDevice.vehicle_no;
				if (v != null && String(v).trim() !== '') {
					this.enquiryForm.vehicle_no = String(v).trim();
				} else {
					this.enquiryForm.vehicle_no = '';
				}
			},

			clearNewCustomerFields() {
				this.enquiryForm.customer_name = '';
				this.enquiryForm.username = '';
				this.enquiryForm.password = '';
			},

			closeEnquiryModal() {
				if (this.enquiryModalInstance) this.enquiryModalInstance.hide();
				this.enquiryDevice = null;
				this.enquiryForm.enquiry_by = '';
				this.enquiryForm.renewal_type = '';
				this.enquiryForm.year_of_expiry = '';
				this.enquiryForm.amount = '';
				this.enquiryForm.vehicle_no = '';
				this.enquiryForm.selectedDealer = null;
				this.enquiryForm.selectedCustomer = null;
				this.enquiryForm.isNewCustomer = false;
				this.enquiryForm.assignToThisDealer = false;
				this.clearNewCustomerFields();
				this.dealerSearch = '';
				this.customerSearch = '';
				this.errors = {};
			},

			submitEnquiry() {
				this.getToken();
				this.errors = {};
				this.enquirySubmitting = true;

				const deviceId = this.enquiryDevice?.device_id || this.enquiryDevice?.id;
				if (!deviceId) {
					this.$swal("", "Device not found", "error");
					this.enquirySubmitting = false;
					return;
				}

				let payload = {
					device_id: deviceId,
					enquiry_by: this.enquiryForm.enquiry_by
				};
				// Always send these fields as strings; backend expects keys present (not null/undefined).
				{
					const rt = this.enquiryForm.renewal_type;
					payload.renewal_type = (rt === null || rt === undefined || rt === "") ? "" : rt;
				}
				{
					const y = this.enquiryForm.year_of_expiry;
					payload.year_of_expiry = (y === null || y === undefined || y === "") ? "" : y;
				}
				// Always send amount: empty string when not set (backend expects key present, not null)
				{
					const a = this.enquiryForm.amount;
					if (a === null || a === undefined || a === "") {
						payload.amount = "";
					} else if (typeof a === "string" && a.trim() === "") {
						payload.amount = "";
					} else {
						payload.amount = a;
					}
				}

				if (this.enquiryForm.enquiry_by == '1') {
					if (!this.enquiryForm.selectedDealer) {
						this.errors.dealer_id = "Please select a dealer";
						this.enquirySubmitting = false;
						return;
					}
					payload.dealer_id = this.enquiryForm.selectedDealer.id;
					payload.is_assign = this.enquiryForm.assignToThisDealer ? 1 : 2;
				} else if (this.enquiryForm.enquiry_by == '2') {
					if (this.enquiryForm.isNewCustomer) {
						if (!this.enquiryForm.customer_name?.trim()) {
							this.errors.customer_name = "Customer name is required";
							this.enquirySubmitting = false;
							return;
						}
						if (!this.enquiryForm.username?.trim()) {
							this.errors.username = "Username is required";
							this.enquirySubmitting = false;
							return;
						}
						if (!this.enquiryForm.password?.trim()) {
							this.errors.password = "Password is required";
							this.enquirySubmitting = false;
							return;
						}
						payload.customer_name = this.enquiryForm.customer_name.trim();
						payload.username = this.enquiryForm.username.trim();
						payload.password = this.enquiryForm.password;
					} else {
						if (!this.enquiryForm.selectedCustomer) {
							this.errors.company_id = "Please select a customer";
							this.enquirySubmitting = false;
							return;
						}
						payload.company_id = this.enquiryForm.selectedCustomer.id;
					}
					payload.vehicle_no = (this.enquiryForm.vehicle_no || '').trim();
				} else {
					this.$swal("", "Please select enquiry by (Dealer or Customer)", "error");
					this.enquirySubmitting = false;
					return;
				}

				const config = {
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + this.token,
					},
				};

				this.$axios
					.post("/staffs/enquiryRequest", payload, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message || "Enquiry submitted successfully", "success");
							this.closeEnquiryModal();
							this.fetchDeviceRenewal(this.active_page_url);
						} else {
							this.applyApiValidationErrors(response.data);
							this.$swal("", this.getApiErrorMessage(response.data), "error");
						}
						this.enquirySubmitting = false;
					})
					.catch((error) => {
						this.enquirySubmitting = false;
						if (error.response) {
							const apiData = error.response.data || {};
							this.applyApiValidationErrors(apiData);
							this.$swal("", this.getApiErrorMessage(apiData, "Something went wrong"), "error");
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			renewDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to renew this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.renew_status.id = device.id;
						this.deviceRenew();
					}
				});
			},

			deviceRenew() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/renewDevice?device_id=" + this.renew_status.id , config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success").then(() => {
								// Call renewal certificate API after successful renewal
								this.generateRenewalCertificate();
							});
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchDeviceRenewal(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			generateRenewalCertificate() {
				this.getToken();
				let page_url = "/staffs/renewelCertificate?device_id=" + this.renew_status.id;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
					.then((response) => {
						let blob = new Blob([response.data], { type: "application/pdf" });
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "Renewal_certificate_" + this.renew_status.id + ".pdf";

						const url = URL.createObjectURL(blob);

						window.open(url, "_blank");

						link.click();
					})
					.catch((err) => {
						console.error("Certificate generation error:", err);
						this.$swal("", "Failed to generate certificate", "error");
					});
			},

			safeCustody(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to move this device to safe custody?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.safe_custody.imei = device.uniqueid;
						this.moveToSafeCustody();
					}
				});
			},

			moveToSafeCustody() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/staffs/moveToSafeCustody?imei=" + this.safe_custody.imei , config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchDeviceRenewal(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			deactivateDevice(device) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this device?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
					}
				});
			},

			generatePDF() 
			{
				this.getToken();
				let page_url = "/staffs/expired_devices_pdf?imei=" + this.imei + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				this.pdf.loading = true;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Device_expire_report" + this.start_date + "_" + this.end_date + ".pdf";

					const url = URL.createObjectURL(blob);

					window.open(url, "_blank");

					link.click();
					this.pdf.loading = false;
						
				})
				.catch((err) => console.log(err));
			},

			generateExcel() {
				this.getToken();
				let page_url = "/api/expired_devices_excel?imei=" + this.imei + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				this.excel.loading = true;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = "Device_expired_data_" + this.start_date + "_" + this.end_date + ".xlsx";
					document.body.appendChild(link); // For Firefox compatibility
					link.click();
					document.body.removeChild(link); 
					this.excel.loading = false;
						
				})
				.catch((err) => console.log(err));
			},

		},
	};
</script>
